module.exports = __webpack_public_path__ + "img/upload-csv.28270c1e.png";